import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const tableHeaderCellSx: SystemStyleObject<Theme> = {
  border: 'none',
  py: 1,
  fontSize: '14px',
  fontWeight: 400,
  color: 'text.secondary',
};
